export class Uuid {
    uuid: string;

    constructor(uuid?: string) {
        if (uuid) {
            this.uuid = uuid;
        }
    }
}

export class Id {
    id: string;

    constructor(id?: string) {
        if (id) {
            this.id = id;
        }
    }
}

export class EmptyDto {}

export class ContentDto<T = any> {
    content: T[];
}
